import tippy from 'tippy.js';
import { defineNuxtPlugin } from '#app';
import 'tippy.js/dist/tippy.css';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('tooltip', {
    mounted(el, binding) {
      if (binding.value.hideTooltip) return;

      tippy(el, {
        content: binding.value.text || 'Default tooltip',
        placement: 'top',
        theme: 'light',
        arrow: true,
        ...binding.value.options
      });
    },
    updated(el, binding) {
      if (el._tippy) {
        el._tippy.setContent(binding.value.text || 'Default tooltip');
      }
    },
    unmounted(el) {
      if (el._tippy) {
        el._tippy.destroy();
      }
    }
  });
});
